export enum PaymentInformationType {
  StepCompleterName = 1,
  ReceiptNumberFor = 2,
  TotalPaidFor = 3
}

export const PaymentInformationTypeDisplay: {[key in PaymentInformationType]: {label: string, type: string}} = {
  [PaymentInformationType.StepCompleterName] : { label: "Step Completer Name", type: 'string (readonly)' },
  [PaymentInformationType.ReceiptNumberFor]: { label: "Receipt Number", type: 'string (readonly)' },
  [PaymentInformationType.TotalPaidFor]: { label: "Total Paid", type: 'number (readonly)' },
}

export enum PaymentLineItemInformationType {
  Name = 1,
  Type = 2,
  SKU = 3,
  Amount = 4,
  Description = 5,
  DateOfPayment = 6,
}

export const PaymentLineItemInformationTypeDisplay: { [key in PaymentLineItemInformationType]: { label: string, type: string } } = {
  [PaymentLineItemInformationType.Name]: {label: 'Line Item Name', type: 'string (readonly)'},
  [PaymentLineItemInformationType.Type]: {label: 'Line Item Type', type: 'string (readonly)'},
  [PaymentLineItemInformationType.SKU]: {label: 'Line Item SKU', type: 'string (readonly)'},
  [PaymentLineItemInformationType.Amount]: {label: 'Line Item Amount', type: 'number (readonly)'},
  [PaymentLineItemInformationType.Description]: {label: 'Line Item Description', type: 'string (readonly)'},
  [PaymentLineItemInformationType.DateOfPayment]: {label: 'Date of Payment', type: 'datetime (readonly)'},
}
